function initializeFlashMessages(container) {
  if (!container) return;

  const closeButtons = container.querySelectorAll(".flash-close-button");
  const timeoutDuration = 5000;

  setTimeout(() => {
    container.querySelectorAll(".alert").forEach((alert) => {
      fadeOut(alert, () => {
        if (alert && alert.parentNode) {
          alert.parentNode.removeChild(alert);

          if (container.querySelectorAll(".alert").length === 0 && !container.classList.contains('saq-player-flash-messages')) {
            // Keep the design-system toast host in the layout.
            if (container.classList.contains("flash-toast-stack")) return;

            if (container.parentNode) {
              container.parentNode.removeChild(container);
            }
          }
        }
      });
    });
  }, timeoutDuration);

  closeButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const flashMessageDiv = button.closest(".alert");
      if (flashMessageDiv) {
        fadeOut(flashMessageDiv, () => {
          if (flashMessageDiv.parentNode) {
            flashMessageDiv.parentNode.removeChild(flashMessageDiv);

            if (container.querySelectorAll(".alert").length === 0) {
              if (container.classList.contains("flash-toast-stack")) return;
              if (container.parentNode) {
                container.parentNode.removeChild(container);
              }
            }
          }
        });
      }
    });
  });
}

function fadeOut(element, callback) {
  element.style.transition = "opacity 0.5s ease";
  element.style.opacity = 0;

  setTimeout(() => {
    if (callback) callback();
  }, 500);
}

function toastVariantForFlashType(type) {
  switch (type) {
    case "success":
      return "success";
    case "warning":
      return "warning";
    case "notice":
    case "information":
      return "information";
    default:
      return "error";
  }
}

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

// Design-system flash host (#flash-messages.flash-toast-stack) expects aqui_toast markup.
function showDesignSystemToast(container, message, type) {
  const alreadyShown = [...container.querySelectorAll(".toast-message")].some((node) =>
    node.textContent.replace(/\s+/g, " ").includes(message),
  );
  if (alreadyShown) return;

  const variant = toastVariantForFlashType(type);
  const messageId = `toast-msg-${Date.now()}`;
  const outer = document.createElement("div");
  outer.className = "toast-outer";
  outer.dataset.controller = "railsui-toast";
  outer.dataset.railsuiToastTriggerOnLoadValue = "true";
  outer.dataset.railsuiToastRemoveOnHideValue = "true";
  outer.dataset.turboTemporary = "";
  outer.innerHTML = `
    <div
      role="status"
      aria-live="assertive"
      aria-atomic="true"
      tabindex="-1"
      class="toast-bar toast-bar-${variant}"
      data-action="keydown.escape->railsui-toast#hide"
      aria-labelledby="${messageId}"
    >
      <p id="${messageId}" class="toast-message">${escapeHtml(message)}</p>
      <button
        type="button"
        class="toast-dismiss"
        data-action="click->railsui-toast#hide keydown.escape->railsui-toast#hide"
        aria-label="Dismiss notification"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-4" aria-hidden="true">
          <path d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
        </svg>
      </button>
    </div>
  `;

  container.prepend(outer);
}

export function showPageFlash(message, type = "error") {
  if (!message) return;

  let container = document.getElementById("flash-messages");
  if (!container) {
    container = document.createElement("div");
    container.id = "flash-messages";
    container.className = "flash-content";
    document.body.prepend(container);
  }

  if (container.classList.contains("flash-toast-stack")) {
    showDesignSystemToast(container, message, type);
    return;
  }

  const alreadyShown = [...container.querySelectorAll(".alert")].some((alert) =>
    alert.textContent.replace(/\s+/g, " ").includes(message)
  );
  if (alreadyShown) return;

  const alert = document.createElement("div");
  alert.className = `alert alert-${type}`;
  alert.setAttribute("role", "alert");
  alert.tabIndex = -1;
  alert.appendChild(document.createTextNode(message));

  const close = document.createElement("button");
  close.type = "button";
  close.className = "aq-card-close-btn fas fa-times flash-close-button";
  close.title = "Remove";
  alert.appendChild(close);

  container.prepend(alert);
  initializeFlashMessages(container);
}

document.addEventListener("turbo:load", () => {
  const flashMessagesContainer = document.getElementById("flash-messages");
  initializeFlashMessages(flashMessagesContainer);
});

document.addEventListener("turbo:before-stream-render", (event) => {
  const targetId = event.target.getAttribute("target");
  if (targetId === "flash-messages" || targetId === "saq-player-flash-messages") {
    setTimeout(() => {
      const updatedFlashMessages = document.getElementById(targetId);
      initializeFlashMessages(updatedFlashMessages);
    }, 10);
  }
});
